import React from 'react';
import {
  SectionNotification,
  TextButton,
  TextButtonPriority,
} from 'wix-ui-tpa/cssVars';

import { classes, st } from './AvailabilityNotification.st.css';

export type AvailabilityNotificationProps = {
  text: string;
  buttonText?: string;
  onButtonClick?: () => void;
  className?: string;
  dataHook?: string;
};

const AvailabilityNotification: React.FC<AvailabilityNotificationProps> = ({
  text,
  buttonText,
  onButtonClick,
  className,
  dataHook,
}) => {
  const showButton = !!buttonText && !!onButtonClick;

  return (
    <SectionNotification
      className={st(classes.root, className)}
      data-hook={dataHook}
      type="default"
    >
      <SectionNotification.Text>{text}</SectionNotification.Text>
      {showButton ? (
        <TextButton
          className={classes.button}
          priority={TextButtonPriority.link}
          onClick={onButtonClick}
        >
          {buttonText}
        </TextButton>
      ) : null}
    </SectionNotification>
  );
};

export default AvailabilityNotification;
